import { i18n } from '@/main.js'
import { router } from '@/router'
import {
  fetchToken,
  fetchMetadata,
  fetchServices,
  fetchInspectionReportUrl,
  fetchAdvisor,
  fetchTax,
  postServices,
  postLog,
  fetchStripePaymentMethods,
} from '@/services'

export const actions = {
  async getMetadata ({ state, commit, dispatch }) {
    commit('setLoading', { key: 'getMetadata', loading: true })
    await fetchMetadata()
      .then((response) => {
        const {
          dealerContactInfo,
          declinedReasons,
          firstName,
          lastName,
          isBusiness,
          customerConcernsLabel,
          customerCommentsLabel,
          supportedLanguages,
          serviceCategories,
          local,
          promise,
          responseBy,
          expired,
          topImageUrl,
          financingOptUrls,
          dealerId,
          inspectionLevelMediaUrl,
          inspectionLevelMediaUrls,
          isDisableDeclineReasons,
          isGuestPaymentEnabled,
          authenticationAnswer,
          isReadOnly,
          isCompletedByAdvisor,
          customerSignature
        } = response

        const order = {
          1: 2,
          2: 3,
          3: 4,
          4: 5,
          5: 1
        }
        let categories = serviceCategories.map((category) => {
          return {
            ...category,
            sortOrder: order[category.id]
          }
        })
        categories.sort((a, b) => a.sortOrder - b.sortOrder)
        categories = categories.map((category) => {
          if (category.id === '5') {
            return {
              ...category,
              name: customerConcernsLabel
            }
          } else { return category }
        })
        commit('setCustomerCommentsLabel', customerCommentsLabel)
        commit('setLanguages', supportedLanguages)
        commit('setCustomer', { firstName, lastName, isBusiness })
        commit('setCategories', categories)
        commit('setReasons', declinedReasons)
        commit('setDefaultLocale', local)
        if (!state.locale.selected) {
          commit('setLocale', local)
          i18n.locale = state.locale.selected
        }
        commit('setRespondBy', responseBy)
        commit('setReadyBy', promise)
        commit('setExpired', expired)
        commit('setDealer', dealerContactInfo)
        commit('setDmpiLinks', financingOptUrls)
        commit('setTopImageUrl', topImageUrl || '')
        commit('setDealerId', dealerId)
        commit('setInspectionLevelMediaUrl', inspectionLevelMediaUrl)
        commit('setinspectionLevelMediaUrls', inspectionLevelMediaUrls)
        commit('setDisableDeclineReasons', isDisableDeclineReasons)
        commit('setReadOnly', isReadOnly)
        commit('setCompletedByAdvisor', isCompletedByAdvisor)
        commit('setCustomerSignature', customerSignature)
        commit('setGuestPaymentEnabled', isGuestPaymentEnabled)
        commit('setCode', authenticationAnswer)
        dispatch('routeAfterMetadata')
      })
      .then(() => {
        if (state.code && !state.expired) {
          dispatch('logIn')
        }
      })
      .catch((error) => {
        dispatch('handleError', error)
      })
      .finally(() => {
        commit('setLoading', { key: 'getMetadata', loading: false })
      })
  }, 
  async getStripePaymentMethods ({ commit, dispatch }) {
    commit('setLoading', { key: 'getStripePaymentMethods', loading: true })
    await fetchStripePaymentMethods()
      .then((responses) => {
        commit('setStripePaymentMethods', responses)
      })
      .catch((error) => {
        commit('setStripePaymentMethods', [])
      })
      .finally(() => {
        commit('setLoading', { key: 'getStripePaymentMethods', loading: false })
      })
  },
  async getTax ({ commit, dispatch, getters, state }) {
    let selectedServiceIds = []
    state.services.forEach((service) => {
      if (service.category !== '3' && service.category !== '4') {
        if (service.subServices) {
          service.subServices.forEach((subService) => {
            if (subService.isSelected) {
              selectedServiceIds.push(subService.id)
            }
          })
        } else {
          if (service.isSelected) {
            selectedServiceIds.push(service.id)
          }
        }
      }
    })

    const previouslyApprovedServiceIds = getters.previouslyApprovedServices.map(service => service.id)
    selectedServiceIds = selectedServiceIds.filter(id => !previouslyApprovedServiceIds.includes(id))

    commit('setLoading', { key: 'getTax', loading: true })

    Promise.all([fetchTax(selectedServiceIds), fetchTax(previouslyApprovedServiceIds)])
      .then((responses) => {
        const [newlyApprovedServicesTaxResponse, previouslyApprovedServicesTaxResponse] = responses
        commit('setNewlyApprovedTax', newlyApprovedServicesTaxResponse.taxAndFee)
        commit('setPreviouslyApprovedTax', previouslyApprovedServicesTaxResponse.taxAndFee)
      })
      .catch((error) => {
        error.message = i18n.t('we_couldnt_get_tax')
        dispatch('handleError', error)
      })
      .finally(() => {
        commit('setLoading', { key: 'getTax', loading: false })
      })
  },
  async handleError ({ state, commit }, e) {
    let text = i18n.t('something_went_wrong')
    try {
      if (e.message) {
        text = e.message
      } else if (e.response) {
        await e.response.json().then((response) => {
          if (typeof response.error === 'string') {
            text = `${i18n.t('were_sorry_we_dont_recognize')} ${state.code} ${i18n.t('in_our_database')}`
          }
        })
      }
    } catch (e) {
      console.log('DMPI error: ', e)
    }
    commit('setError', text)
  },
  async logIn ({ commit, dispatch }) {
    commit('setLoading', { key: 'logIn', loading: true })
    await fetchToken()
      .then((response) => {
        commit('setToken', response.access_token)
        Promise.all([fetchServices(), fetchInspectionReportUrl(), fetchAdvisor()])
          .then((responses) => {
            const [servicesResponse, inspectionReportUrlResponse, advisor] = responses

            let additional = false
            const parentServices = []
            for (const service of servicesResponse) {
              service.isApproveSelected = false;
              service.isDeferSelected = false;
              if(service.isApproved !== null && service.isApproved !== undefined )
              {
                if(service.isApproved)
                {
                  service.isApproveSelected = true;
                  service.isDeferSelected = false;
                }
  
                if(!service.isApproved)
                {
                  service.isApproveSelected = false;
                  service.isDeferSelected = true;
                  service.isSelected = false;
                } 
              }

              if (
                typeof service.declinedReasonId === 'number' &&
                service.declinedReasonId > -1 &&
                service.declinedReasonId !== 8
              ) {
                service.deferred = true
              } else {
                service.deferred = false
              }
              if (service.isHighlighted) {
                additional = true
              }
              if (!service.parentServiceId) {
                if (!parentServices.some((duplicate) => duplicate.id === service.id)) {
                  parentServices.push(service)
                }
              }
            }

            if (additional) {
              for (const service of servicesResponse) {
                if (service.deferred) {
                  if (
                    service.category === '1' ||
                    service.category === '2' ||
                    service.category === '6' ||
                    service.category === '7'
                  ) {
                    service.isSelected = false
                  }
                }
              }
            }

            for (const parentService of parentServices) {
              const subServices = servicesResponse
                .filter((subService) => subService.parentServiceId === parentService.id)
              if (subServices.length) {
                parentService.subServices = subServices
              }
            }
            commit('setServices', parentServices)
            commit('setAdvisor', advisor)
            commit('setInspectionReportUrl', inspectionReportUrlResponse.fullInspectionUrl)
            dispatch('routeAfterLogin')
          })
      })
      .catch((error) => {
        dispatch('handleError', error)
        commit('setLoading', { key: 'logIn', loading: false })
      })
  },
  sendLog () {
    postLog()
      .catch((error) => {
        console.log({ error })
      })
  },
  async sendServices ({ commit, dispatch }) {
    commit('setLoading', { key: 'sendServices', loading: true })
    await postServices()
      .then(() => {
        dispatch('routeAfterApprove')
      })
      .catch((error) => {
        dispatch('handleError', error)
      })
      .finally(() => {
        commit('setLoading', { key: 'sendServices', loading: false })
      })
  },
  routeAfterApprove ({ commit }) {
    router.push({ name: 'thanks' })
    commit('setExpired', true)
  },
  routeAfterLogin ({ commit, getters, state }) {
    if (getters.additionalServices.length) {
      if (state.route.query.src) {
        router.push({ name: 'additional',  query: { src:state.route.query.src } })
      } else {
        router.push({ name: 'additional' })
      }
    } else {
      if (state.route.query.src) { 
        router.push({ name: 'at-a-glance', query: { src: state.route.query.src } })
      } else {
        router.push({ name: 'at-a-glance'})
      } 
    }
    commit('setLoading', { key: 'logIn', loading: false })
  },
  routeAfterMetadata ({ state }) {
    if (state.expired) {
      router.push({ name: 'link-expired'})
    }
  },
  viewService ({ commit, state }, service) {    
    if(service === undefined && state.inspectionLevelMediaUrls !== null) {
      let serviceOnject = {
        category: "",
        comment: "",
        declinedReasonId: null,
        deferred: false,
        iconUrl: null,
        id: "",
        selectedImageURL: service,
        imageUrl: state.inspectionLevelMediaUrl,
        imageUrls: state.inspectionLevelMediaUrls,
        isHighlighted: false,
        isSelected: false,
        isApproveSelected: false,
        isDeferSelected: false,
        isApproved: null,       
        laborMatrixPayment: "",
        laborMatrixPaymentTranslations: null,
        name: "",
        parentServiceId: "",
        price: null,
        serviceAdvisorComments: "",
        taxAndFee: 0,
        hideFooter: true,
        oldApp: state.inspectionLevelMediaUrls === null ? true : false

      }  
        commit('setService', serviceOnject)
        if (!state.modal) {
        commit('openService')
      }
    } else  if(typeof service === 'string') {
      let serviceOnject = {
        category: "",
        comment: "",
        declinedReasonId: null,
        deferred: false,
        iconUrl: null,
        id: "",
        selectedImageURL: service,
        imageUrl: state.inspectionLevelMediaUrl,
        imageUrls: state.inspectionLevelMediaUrls,
        isHighlighted: false,
        isSelected: false,
        isApproveSelected: false,
        isDeferSelected: false,
        isApproved: null,      
        laborMatrixPayment: "",
        laborMatrixPaymentTranslations: null,
        name: "",
        parentServiceId: "",
        price: null,
        serviceAdvisorComments: "",
        taxAndFee: 0,
        hideFooter: true,
        fromInspection: true,
        oldApp: state.inspectionLevelMediaUrls === null ? true : false
      }  
        commit('setService', serviceOnject)
        if (!state.modal) {
        commit('openService')
      }
    } else {
      if (state.service.id !== undefined) {
        commit('logEvent', `Finished viewing service ${service.id}`)
      }
      service['fromInspection'] = false;
      service['oldApp'] = state.inspectionLevelMediaUrls === null ? true : false;
      commit('setService', service)
      commit('logEvent', `Started viewing service ${service.id}`)
      if (!state.modal) {
        commit('openService')
      }
    }
  }
}

export default actions
